import React from "react";
import style from "./style.module.scss";
import ChildTableRow from "./child-table-row";
import { formatCurrency } from "../../../../../../../components/helper/helper";

function ChildTable({ data = [], handleRemoveMember, updateMemberStatus }) {
  const getTotalTransactionAmount = () => {
    return data.reduce(
      (total, transaction) => total + transaction.trans_amt,
      0,
    );
  };

  const getTotalNetAmount = () => {
    return data.reduce((total, transaction) => total + transaction.net_amt, 0);
  };

  const getTotalAdjAmount = () => {
    return data.reduce((total, transaction) => total + transaction.adj_amt, 0);
  };

  return (
    <tr className={style.child_row}>
      <td colSpan={11} className={style.child_row_cell}>
        <table className={style.child_table}>
          <thead>
            <tr className={`${style.child_header_row} ${style.line_after}`}>
              <th></th> <th></th>           
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              return (
                <ChildTableRow
                  data={row}
                  key={row?.id ?? index}
                  lastRow={data?.length == index + 1}
                  handleRemoveMember={handleRemoveMember}
                  updateMemberStatus={updateMemberStatus}
                />
              );
            })}      
          </tbody>
        </table>
      </td>
    </tr>
  );
}

export default ChildTable;
